import { render, staticRenderFns } from "./BuscarProveedores.vue?vue&type=template&id=66de3897&scoped=true"
import script from "./BuscarProveedores.vue?vue&type=script&lang=js"
export * from "./BuscarProveedores.vue?vue&type=script&lang=js"
import style0 from "./BuscarProveedores.vue?vue&type=style&index=0&id=66de3897&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66de3897",
  null
  
)

export default component.exports